/** @jsxImportSource react */
import Logo from '@react/shared/components/Logo';
import ProgressBar from '@react/shared/components/ProgressBar';
import Link from '@react/system/Link';
import * as React from 'react';

export default function SurveyTemplate({
  totalPage,
  currentPage,
  isMultiStep = false,
  children,
}: {
  totalPage?: number;
  currentPage?: number;
  isMultiStep: boolean;
  children: React.ReactNode;
}) {
  return (
    <>
      <div
        className='mb-0'
        data-tp-id='gen-div-1f94658d-ebce-40bf-9a82-3834e80b8823'
      >
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*@ts-ignore*/}
        <Link
          to='/'
          className='flex h-20 items-center justify-center border-[1px] border-[#E7E8EA]'
          data-tp-id='gen-Link-1f3ddf0c-61fc-4198-bfc1-af6148bcc706'
        >
          <Logo />
        </Link>
      </div>
      {isMultiStep && (
        <div
          className='w-full'
          data-tp-id='gen-div-bb77f56e-e8d2-4c96-86ff-da4ca6ca18e7'
        >
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/*@ts-ignore*/}
          <ProgressBar maxValue={totalPage} value={currentPage} />
        </div>
      )}
      <div
        className='flex min-h-[calc(100vh-80px)] w-full flex-row items-center justify-between bg-harvest-lighter-90 p-0 md:justify-start'
        data-tp-id='gen-div-d8a52c94-f4c3-4999-bbff-7409f7cde5c0'
      >
        <div
          className='mx-auto my-0 flex lg:max-w-[1280px]'
          data-tp-id='gen-div-1f78e330-1c0b-41a7-a430-2ba2d7e8d13c'
        >
          <section className='grid w-full justify-center justify-evenly gap-6 bg-harvest-lighter-90 p-6 md:grid-cols-[100%]'>
            <section className='h-fit w-[360px] rounded bg-white p-6 md:w-[504px]'>
              <>{children}</>
            </section>
          </section>
        </div>
      </div>
    </>
  );
}
